
// import talents from '@/router/modules/talents'
import { defineComponent, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
    components: {},
    props: {},
    setup() {
        const route = useRoute()
        const router = useRouter()
        let { name } = route.query
        const viewDetail = (type: any) => {
            router.push({
                name: 'Content',
                query: {
                    name,
                    type,
                    category: 'Team',
                },
            })
        }
        return {
            viewDetail,
        }
    },
})
